<div style="padding: 2rem;">

  <!-- Page header -->
  <div style="margin-bottom: 1.75rem;">
    <h1 style="font-size: 1.5rem; font-weight: 700; color: #1e293b; margin: 0 0 0.25rem;">
      Réservations de véhicules
    </h1>
    <p style="font-size: 0.875rem; color: #64748b; margin: 0;">Gestion des réservations de location de véhicules</p>
  </div>

  <!-- Main card -->
  <div class="afri-card">

    <!-- Card header: actions + filter + count -->
    <div class="afri-card-header">
      <div class="flex items-center gap-2 flex-wrap" *ngIf="buttonsPermission">
        <button *ngIf="buttonsPermission.show" (click)="show(showContent)" class="btn-afri-outline">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
          </svg>
          Consulter
        </button>
        <button *ngIf="buttonsPermission.status && selected_data?.status=='pending'" (click)="changeStatus('confirmed')" [disabled]="loading" class="btn-afri-success">
          Confirmer <app-loading [isVisible]="loading"></app-loading>
        </button>
        <button *ngIf="buttonsPermission.status && selected_data?.status=='confirmed'" (click)="changeStatus('completed')" [disabled]="loading" class="btn-afri-success">
          Marquer terminée <app-loading [isVisible]="loading"></app-loading>
        </button>
        <button *ngIf="buttonsPermission.status && (selected_data?.status=='pending' || selected_data?.status=='confirmed')" (click)="changeStatus('cancelled')" [disabled]="loading" class="btn-afri-danger">
          Annuler <app-loading [isVisible]="loading"></app-loading>
        </button>

        <select class="form-select" style="max-width: 220px;" [(ngModel)]="statusFilter" (ngModelChange)="onFilterChange()">
          <option value="">Tous les statuts</option>
          <option value="pending">En attente</option>
          <option value="confirmed">Confirmée</option>
          <option value="completed">Terminée</option>
          <option value="cancelled">Annulée</option>
        </select>
      </div>
      <div class="flex items-center gap-2" style="font-size: 0.875rem; color: #64748b;">
        <span style="font-weight: 700; color: #1e293b; font-size: 1rem;">{{ filteredData.length }}</span>
        élément(s)
        <app-loading [isVisible]="loading2"></app-loading>
      </div>
    </div>

    <!-- Table -->
    <div style="overflow-x: auto;">
      <table class="afri-table">
        <thead>
          <tr>
            <th style="width: 52px; padding-left: 1.5rem;">#</th>
            <th>Client</th>
            <th>Véhicule</th>
            <th>Catégorie</th>
            <th>Du</th>
            <th>Au</th>
            <th>Prix total</th>
            <th>Statut</th>
            <th>Paiement</th>
            <th>Réservé le</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let d of filteredData | paginate: {
                id: 'ngxP1',
                itemsPerPage: pg.pageSize,
                currentPage: pg.p,
                totalItems: filteredData.length
              } | sampleSearch:search_text"
              [style.background]="selected_data?.id === d.id ? '#f0f4ff' : ''">
            <td style="padding-left: 1.5rem;">
              <input (click)="checked(d)" type="radio" name="selectRow"
                     style="width: 16px; height: 16px; accent-color: #2E3190; cursor: pointer;">
            </td>
            <td>{{d.user?.name}}</td>
            <td>{{d.car?.name}} ({{d.car?.brand}})</td>
            <td>{{d.car?.category?.name}}</td>
            <td>{{d.start_date | date:"dd/MM/yyyy"}}</td>
            <td>{{d.end_date | date:"dd/MM/yyyy"}}</td>
            <td>{{d.total_price}} F</td>
            <td><app-status [value]="d.status"></app-status></td>
            <td><app-status [value]="d.payment_status"></app-status></td>
            <td>{{d.created_at | date:"dd/MM/yyyy"}}</td>
          </tr>

          <tr *ngIf="filteredData.length === 0 && !loading2">
            <td colspan="10" style="padding: 4rem 1.25rem; text-align: center;">
              <div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem; color: #94a3b8;">
                <svg class="w-12 h-12" style="color: #e2e8f0;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                </svg>
                <p style="margin: 0; font-weight: 500;">Aucun élément trouvé</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div style="padding: 0.5rem 1.5rem 1.25rem;">
      <pagination-controls
        id="ngxP1"
        (pageChange)="getPage($event)"
        [maxSize]="9"
        [directionLinks]="true"
        [autoHide]="true"
        [responsive]="true"
        [previousLabel]="'Précédent'"
        [nextLabel]="'Suivant'">
      </pagination-controls>
    </div>

  </div>
</div>

<ng-template #showContent let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Détails de la réservation</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="row g-3">
      <div class="col-6">
        <strong>Client :</strong>
        <div>{{selected_data?.user?.name}}</div>
      </div>
      <div class="col-6">
        <strong>Téléphone :</strong>
        <div>{{selected_data?.user?.phone_number}}</div>
      </div>
      <div class="col-6">
        <strong>Véhicule :</strong>
        <div>{{selected_data?.car?.name}} ({{selected_data?.car?.brand}} {{selected_data?.car?.model}})</div>
      </div>
      <div class="col-6">
        <strong>Propriétaire :</strong>
        <div>{{selected_data?.car?.owner?.name}}</div>
      </div>
      <div class="col-6">
        <strong>Du :</strong>
        <div>{{selected_data?.start_date | date:"dd/MM/yyyy"}}</div>
      </div>
      <div class="col-6">
        <strong>Au :</strong>
        <div>{{selected_data?.end_date | date:"dd/MM/yyyy"}}</div>
      </div>
      <div class="col-6">
        <strong>Prix total :</strong>
        <div>{{selected_data?.total_price}} F</div>
      </div>
      <div class="col-6">
        <strong>Statut paiement :</strong>
        <div><app-status [value]="selected_data?.payment_status"></app-status></div>
      </div>
      <div class="col-6">
        <strong>Statut réservation :</strong>
        <div><app-status [value]="selected_data?.status"></app-status></div>
      </div>
      <div class="col-6">
        <strong>Réservé le :</strong>
        <div>{{selected_data?.created_at | date:"dd/MM/yyyy HH:mm"}}</div>
      </div>
    </div>
  </div>
</ng-template>
